import type { SVGProps } from "react";

// fill prop controls the surround color — defaults to cream, transitions to gold when pressed
const SvgSolveButtonSurround = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="234pt"
    height="84.001pt"
    viewBox="19.22 -720.53 234 84.001"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <path
        d="M 19.22,708.65 L 19.22,648.409 C 19.22,641.852 23.079,636.529 27.833,636.529 L 244.607,636.529 C 249.361,636.529 253.22,641.852 253.22,648.409 L 253.22,708.65 C 253.22,715.208 249.361,720.53 244.607,720.53 L 27.833,720.53 C 23.079,720.53 19.22,715.208 19.22,708.65 Z"
        fill={fill ?? "currentColor"}
        stroke="none"
        strokeLinecap="round"
        strokeWidth={0.652}
        strokeLinejoin="miter"
        markerStart="none"
        markerEnd="none"
      />
    </g>
  </svg>
);
export default SvgSolveButtonSurround;
